export interface FilterState {
  filterString: string;
}

const filterString = '';

export const initialFilterState: FilterState = {
  filterString: filterString
};
